
import clientAuth from "../clientAuth"
export default {
    index: () => clientAuth.get(`calender/index`),
    
    destroy: (id) => clientAuth.delete(`calender/destroy/${id}`),
    // store: (userData) => clientAuth.post('calender/store', { json: userData }),   

};